import React from 'react';

export default function Footer() {
	return (
		<footer>
			<div className='footer--wrapper'>
				<p>
					Designed and built by David Schaeffer. See the code{' '}
					<a
						href='https://github.com/dbschaeffer29/my-site'
						rel='noopener noreferrer'
						target='_blank'
					>
						here
					</a>
					.
				</p>
			</div>
		</footer>
	);
}
